import { render, staticRenderFns } from "./FlashcardDeckList.vue?vue&type=template&id=32a2ebba&scoped=true&"
import script from "./FlashcardDeckList.vue?vue&type=script&lang=js&"
export * from "./FlashcardDeckList.vue?vue&type=script&lang=js&"
import style0 from "./FlashcardDeckList.vue?vue&type=style&index=0&id=32a2ebba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a2ebba",
  null
  
)

export default component.exports